import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67d9b542&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=67d9b542&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=67d9b542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d9b542",
  null
  
)

export default component.exports